<script setup>
import { inject, computed } from 'vue'

const props = defineProps({
  title:   { type: String, default: '' },
  colspan: { type: [Number, String], default: null },
  spaced:  { type: Boolean, default: false }, // adds top spacing before this group (skip for the first group)
})

const injectedColspan = inject('reportTableColspan', computed(() => 1))
const resolvedColspan = computed(() => props.colspan ?? injectedColspan.value)
</script>

<template lang="pug">
tr.no-bottom-border
  td.px-0.py-0(:colspan="resolvedColspan" :class="spaced ? 'pt-6' : ''")
    .text-center.py-4.bg-canvas-600.text-3xl.text-canvas-100
      slot {{ title }}
</template>
